var map = {
	"./1-1-p2.svg": "9d0c",
	"./1-2-p2.svg": "44e8",
	"./1-3-p2.svg": "c978",
	"./1-4-p2.svg": "c981",
	"./1-5-p2.svg": "1118"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54f8";